import { jsx as _jsx } from "react/jsx-runtime";
import { PopoverPrimitiveHoverGroupContext } from '#pplx/frontend/aether/primitives/PopoverPrimitive/PopoverPrimitiveHoverGroupContext.js';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
const HOVER_CARD_SKIP_DELAY_MS = 300;
/**
 * Coordinates instant transitions between sibling hover cards. Nested providers create
 * independent groups.
 */
export function PopoverPrimitiveHoverGroup({ children, }) {
    const isMountedRef = useRef(true);
    const openHoverCardsRef = useRef(new Map());
    const resetTimerRef = useRef(undefined);
    const [shouldSkipOpenDelay, setShouldSkipOpenDelay] = useState(false);
    const prepareToOpen = useCallback((hoverCardId) => {
        openHoverCardsRef.current.forEach((hoverCard, openHoverCardId) => {
            if (openHoverCardId !== hoverCardId)
                hoverCard.prepareForClose();
        });
    }, []);
    const reportOpenState = useCallback((hoverCardId, isOpen, requestClose, prepareForClose) => {
        if (!isMountedRef.current)
            return;
        if (isOpen) {
            openHoverCardsRef.current.forEach((hoverCard, openHoverCardId) => {
                if (openHoverCardId !== hoverCardId)
                    hoverCard.requestClose();
            });
            openHoverCardsRef.current.set(hoverCardId, { prepareForClose, requestClose });
            clearTimeout(resetTimerRef.current);
            resetTimerRef.current = undefined;
            setShouldSkipOpenDelay(true);
            return;
        }
        const wasOpen = openHoverCardsRef.current.delete(hoverCardId);
        if (!wasOpen || openHoverCardsRef.current.size > 0)
            return;
        clearTimeout(resetTimerRef.current);
        resetTimerRef.current = setTimeout(() => {
            setShouldSkipOpenDelay(false);
            resetTimerRef.current = undefined;
        }, HOVER_CARD_SKIP_DELAY_MS);
    }, []);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            clearTimeout(resetTimerRef.current);
        };
    }, []);
    const contextValue = useMemo(() => ({
        prepareToOpen,
        reportOpenState,
        shouldSkipOpenDelay,
    }), [prepareToOpen, reportOpenState, shouldSkipOpenDelay]);
    return (_jsx(PopoverPrimitiveHoverGroupContext.Provider, { value: contextValue, children: children }));
}
//# sourceMappingURL=PopoverPrimitiveHoverGroup.js.map